import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { analytics } from '../../services/analytics';
import SEOPageLayout from '../../components/SEOPageLayout';

const ConstructionBidOptions = () => {
  useEffect(() => {
    analytics.track('Template Page View', { template: 'Construction Bid Options' });
  }, []);

  return (
    <SEOPageLayout
      title="Construction Bid Template with Options - Win More Jobs | QuoteTier"
      description="Stop losing bids on price. Offer 'Standard', 'Premium', and 'Luxury' material options in a single construction bid template."
      canonical="/templates/construction-bid-options-template"
      ogTitle="The Construction Bid Template That Upsells"
      ogDescription="Don't just bid the basics. Show them what an upgrade looks like. Let clients choose their own finish levels."
    >
      <section className="py-32 md:py-40 lg:py-48">
        <div className="container max-w-7xl mx-auto px-4">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="font-instrument text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tight leading-tight mb-6">
              Construction Bid <span className="text-primary font-bold">Options</span> Template
            </h1>
            <p className="font-jetbrains text-xl md:text-2xl text-gray-600 tracking-tight leading-relaxed mb-8">
              Give your clients the power to choose their finish level. Stop re-quoting for "cheaper tile" or "better counters".
            </p>
            <div className="font-instrument mt-12 flex flex-col sm:flex-row gap-6 justify-center items-center mb-6">
              <Link to="/signup">
                <Button className="px-8 py-4 text-xl font-semibold bg-black text-white hover:bg-gray-800 rounded-lg shadow-lg">
                  Use This Template Free
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-gray-50">
        <div className="container max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="font-instrument text-3xl md:text-4xl font-bold mb-4">Material Selections Made Easy</h2>
          </div>

          <div className="grid gap-6 md:grid-cols-3">
            <Card className="border border-black">
              <CardHeader><CardTitle className="font-instrument text-xl">Standard</CardTitle><CardDescription>Builder Grade</CardDescription></CardHeader>
              <CardContent>
                  <ul className="font-jetbrains text-sm text-gray-600 list-disc list-inside">
                      <li>Laminate Countertops</li>
                      <li>Standard Vinyl Flooring</li>
                      <li>Chrome Fixtures</li>
                      <li>Basic Lighting Package</li>
                  </ul>
              </CardContent>
            </Card>
            <Card className="border border-black bg-black text-white">
              <CardHeader><CardTitle className="font-instrument text-xl text-white">Premium</CardTitle><CardDescription className="text-gray-300">Most Popular</CardDescription></CardHeader>
              <CardContent>
                  <ul className="font-jetbrains text-sm text-gray-300 list-disc list-inside">
                      <li>Quartz Countertops</li>
                      <li>LVP or Engineered Wood</li>
                      <li>Brushed Nickel Fixtures</li>
                      <li>Recessed LED Lighting</li>
                  </ul>
              </CardContent>
            </Card>
            <Card className="border border-black">
              <CardHeader><CardTitle className="font-instrument text-xl">Luxury</CardTitle><CardDescription>High-End Finishes</CardDescription></CardHeader>
              <CardContent>
                  <ul className="font-jetbrains text-sm text-gray-600 list-disc list-inside">
                      <li>Natural Stone / Marble</li>
                      <li>Hardwood Flooring</li>
                      <li>Designer Fixtures (Gold/Black)</li>
                      <li>Smart Home Integration</li>
                  </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-black text-white">
        <div className="container max-w-4xl mx-auto px-4 text-center">
          <h2 className="font-instrument text-3xl md:text-4xl font-bold mb-6">Win Higher Value Bids</h2>
          <Link to="/signup">
            <Button className="px-10 py-4 font-instrument text-xl font-semibold bg-white text-black hover:bg-gray-200 rounded-lg shadow-lg">
              Get Free Access
            </Button>
          </Link>
        </div>
      </section>
    </SEOPageLayout>
  );
};

export default ConstructionBidOptions;
